import { render, staticRenderFns } from "./siteSettings.vue?vue&type=template&id=54f0f024&"
import script from "./siteSettings.vue?vue&type=script&lang=js&"
export * from "./siteSettings.vue?vue&type=script&lang=js&"
import style0 from "./siteSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports